enum Urls {
    /** 用户登录 */
    WEB_TOKEN_LOGIN = '/auth/login',
    /** 获取列表 */
    queryStoreExtend = '/open-platform/app/info/query-store-extend',
    userConfUpset = '/open-platform/app/instance/user-conf/upsert',
    // 获取我的应用列表
    queryMy = '/open-platform/app/instance/user-conf/query-my',
    multiActivate = '/open-platform/app/instance/multi-activate',
    queryCatoryApp = '/open-platform/app/instance/user-conf/query-classification-instance',
    queryCatory = '/open-platform/app/category/query',
    // 邮箱设置列表
    inputEmailList = '/zone/invoice/biz-logging/email/find-list',
    // 新增邮箱
    inputEmailAdd = '/zone/invoice/biz-logging/email/save',
    // 更新邮箱
    inputEmailUpdate = '/zone/invoice/biz-logging/email/update',
    // 删除邮箱
    inputEmailDelete = '/zone/invoice/biz-logging/email/delete',
}

export default Urls;


// WEBPACK FOOTER //
// ./src/entry/constant/Urls/index.ts